









































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import Loading from 'vue-loading-overlay';
import u from '@/utility/utility';
import { APP_CONFIG } from '@/config/app-config';
import cartServices from '@/services/cart-services';
import commonServices from '@/services/common-services';
import orderService from '@/services/order-service';
import DetailProduct from './DetailProduct.vue';

@Component({
  components: {
    Loading,
    DetailProduct
  }
})
export default class MainDashboard extends Vue {
  private isLoading = false;
  private searchTerm = '';
  private searchSite = 'TAOBAO';
  private showDetailProduct = false;
  private detailProductUrl = '';
  private detailProductKey = 0;
  private addPrice = 0;
  private products: any[] = [];
  private currentPage = 1;
  private pageSize = 20;
  private hasMoreProducts = true;
  private isLoadingMore = false;
  private isSearchingByImage = false;
  private isPasteFocused = false;
  private showImageSearchModal = false;
  private isDragOver = false;

  private notifications: any[] = [];
  private orderStats = {
    waitingDeposit: 0,
    inTransit: 0,
    atWarehouseVN: 0,
  };

  private monthlyChartData = [
    { month: 'Tháng 3', value: 125, percent: 45 },
    { month: 'Tháng 4', value: 190, percent: 60 },
    { month: 'Tháng 5', value: 150, percent: 50 },
    { month: 'Tháng 6', value: 320, percent: 80 },
    { month: 'Tháng 7', value: 280, percent: 70 },
    { month: 'Tháng 8', value: 450, percent: 100 },
  ];

  private searchCategories = [
    { id: 1, name: 'Thời trang nữ', image: '/img/thoi-trang-nu.png' },
    { id: 2, name: 'Thời trang nam', image: '/img/thoi-trang-nam.png' },
    { id: 3, name: 'Thời trang trẻ em', image: '/img/thoi-trang-tre-em.png' },
    { id: 4, name: 'Sản phẩm mẹ và bé', image: '/img/sp-me-va-be.png' },
    { id: 5, name: 'Giày dép', image: '/img/giay-dep.png' },
    { id: 6, name: 'Đồ nội y', image: '/img/do-noi-y.png' },
    { id: 7, name: 'Trang phục thể thao', image: '/img/trang-phuc-the-thao.png' },
    { id: 8, name: 'Đồ chơi', image: '/img/do-choi.png' },
    { id: 9, name: 'Túi xách, vali', image: '/img/tui-xach-vali.png' },
    { id: 10, name: 'Điện thoại', image: '/img/dien-thoai.png' },
    { id: 11, name: 'Linh phụ kiện điện tử', image: '/img/do-dien-tu.png' },
    { id: 12, name: 'Phụ kiện thể thao', image: '/img/phu-kien-the-thao.png' },
    { id: 13, name: 'Điện gia dụng', image: '/img/dien-gia-dung.png' },
    { id: 14, name: 'Thiết bị điện tử', image: '/img/thiet-bi-dien-tu.png' },
    { id: 15, name: 'Trang điểm, mỹ phẩm', image: '/img/trang-diem.png' },
    { id: 16, name: 'Chăm sóc sắc đẹp', image: '/img/cs-sac-dep.png' },
    { id: 17, name: 'Phụ kiện', image: '/img/phu-kien.png' },
    { id: 18, name: 'Dụng cụ đo', image: '/img/dung-cu-do.png' }
  ];

  get customerInfo() {
    return this.$store.state[APP_CONFIG.stateKey.authStore].customerInfo || {};
  }

  get rate() {
    return this.$store.state[APP_CONFIG.stateKey.commonStore].rate || 0;
  }

  get currentDateString() {
    return 'Hôm nay, ' + moment().format('DD/MM/YYYY');
  }

  get unreadNotificationCount() {
    return this.notifications.filter(n => n.status === 0 || n.status === 2).length;
  }

  private async created() {
    if (!this.rate) {
      await this.getRate();
    }
    window.addEventListener('scroll', this.handleScroll);
    await Promise.all([
      this.loadNotifications(),
      this.loadOrderStats()
    ]);
  }

  private beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  private async getRate() {
    const result = await commonServices.exchangeRate();
    if (result && result.status === 200) {
      (window['getApp'] as any).$emit('SET_RATE', result.data.data.exchange_rate);
    }
  }

  private async loadNotifications() {
    try {
      const res = await commonServices.getNotification(1, 8, [], false);
      if (res && res.status === 200 && res.data) {
        this.notifications = res.data.data || [];
      }
    } catch (e) {
      // Ignored
    }
  }

  private async loadOrderStats() {
    try {
      // Fetch order counts
      const res = await orderService.orderList(1, 1, [], []);
      if (res && res.status === 200 && res.data) {
        this.orderStats.waitingDeposit = res.data.total_status_0 || 0;
        this.orderStats.inTransit = (res.data.total_status_4 || 0) + (res.data.total_status_5 || 0);
        this.orderStats.atWarehouseVN = res.data.total_status_6 || 0;
      }
    } catch (e) {
      // Ignored
    }
  }

  private async markAsRead(item: any) {
    if (item.status === 0 || item.status === 2) {
      item.status = 1;
      try {
        await commonServices.updateStatusNotification(item.id, { Status: 1 });
      } catch (e) {
        // Ignored
      }
    }
  }

  private handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    if (scrollTop + windowHeight >= documentHeight - 200) {
      this.loadMoreProducts();
    }
  }

  private isValidURL(str: string) {
    return str.includes('1688.com') || str.includes('taobao.com') || str.includes('tmall.com') || str.includes('e.tb.cn');
  }

  private getDetailProductUrl(itemUrl: string) {
    return `${this.extractItemId(itemUrl)}`;
  }

  private extractItemId(url: string): string {
    if (!url) { return ''; }
    const urlMatch = url.match(/https?:\/\/[^\s]+/);
    if (urlMatch) { url = urlMatch[0]; }
    try {
      const parsedUrl = new URL(url);
      const host = parsedUrl.hostname;
      if (host.includes('taobao.com') || host.includes('tmall.com')) {
        const id = parsedUrl.searchParams.get('id');
        return id ? `https://${host}/item.htm?id=${id}` : url;
      }
      return url;
    } catch (error) {
      return url;
    }
  }

  private async searchProduct() {
    if (!this.searchTerm.trim()) { return; }
    if (this.isValidURL(this.searchTerm)) {
      const detailUrl = this.getDetailProductUrl(this.searchTerm);
      const routeData = this.$router.resolve({ 
        name: 'detail-product-index', 
        query: { itemUrl: detailUrl } 
      });
      window.open(routeData.href, '_blank');
      return;
    }
    
    this.currentPage = 1;
    this.products = [];
    this.hasMoreProducts = true;
    await this.loadSearchResults();
  }

  private async loadSearchResults() {
    if (this.currentPage === 1) {
      this.isLoading = true;
    } else {
      this.isLoadingMore = true;
    }
    
    try {
      const result = await cartServices.searchProductsByKeyword(
        this.searchTerm, 
        this.searchSite.toLowerCase(),
        this.currentPage,
        this.pageSize
      );
      
      if (result && result.status === 200 && result.data) {
        let products: any[] = [];
        if (result.data.success && result.data.items && Array.isArray(result.data.items)) {
          products = result.data.items;
        } else if (result.data.data && result.data.data.items) {
          products = result.data.data.items;
        } else if (result.data.items) {
          products = result.data.items;
        } else if (Array.isArray(result.data.data)) {
          products = result.data.data;
        }
        
        if (this.currentPage === 1) {
          this.products = products;
        } else {
          this.products.push(...products);
        }
        this.hasMoreProducts = products.length === this.pageSize;
      }
    } catch (error) {
      // Ignored
    }
    
    this.isLoading = false;
    this.isLoadingMore = false;
  }

  private searchByKeyword(keyword: string) {
    this.searchTerm = keyword;
    this.searchProduct();
  }

  private clearSearchResults() {
    this.products = [];
    this.searchTerm = '';
    this.currentPage = 1;
    this.hasMoreProducts = true;
  }

  private async loadMoreProducts() {
    if (!this.hasMoreProducts || this.isLoadingMore || !this.searchTerm) {
      return;
    }
    this.currentPage++;
    await this.loadSearchResults();
  }

  private openProductDetail(product: any) {
    const productUrl = product.link || product.url;
    if (productUrl) {
      const detailUrl = this.getDetailProductUrl(productUrl);
      const routeData = this.$router.resolve({ 
        name: 'detail-product-index', 
        query: { itemUrl: detailUrl } 
      });
      window.open(routeData.href, '_blank');
    }
  }

  private getPlatformName(platform: string): string {
    const platformMap: any = {
      'taobao': 'Taobao',
      'tmall': 'Tmall',
      '1688': '1688',
      'TAOBAO': 'Taobao',
      'TMALL': 'Tmall'
    };
    return platformMap[platform] || platform;
  }

  private formatPrice(price: any): string {
    if (!price) { return ''; }
    if (typeof price === 'object' && price.min !== undefined) {
      if (price.min === price.max) { return `¥${price.min}`; }
      return `¥${price.min} - ¥${price.max}`;
    }
    return `¥${price}`;
  }

  private getProductImage(product: any): string {
    if (product.img_url) { return u.proxyImage(product.img_url); }
    if (product.image) { return u.proxyImage(product.image); }
    if (product.images && Array.isArray(product.images) && product.images.length > 0) {
      return u.proxyImage(product.images[0]);
    }
    return '/img/no-image.png';
  }

  private triggerImageUpload() {
    (this.$refs.imageInput as HTMLInputElement).click();
  }

  private async handleImageUpload(event: Event) {
    const target = event.target as HTMLInputElement;
    const files = target.files;
    if (!files || files.length === 0) { return; }
    const file = files[0];
    await this.processImageSearch(file);
    target.value = '';
  }

  private async processImageSearch(file: File) {
    if (!file.type.startsWith('image/')) {
      Vue.notify({
        group: 'foo',
        type: 'error',
        title: 'Lỗi!',
        text: 'Vui lòng chọn file ảnh hợp lệ (JPG, PNG, GIF)',
      });
      return;
    }

    if (file.size > 10 * 1024 * 1024) {
      Vue.notify({
        group: 'foo',
        type: 'error',
        title: 'Lỗi!',
        text: 'File ảnh không được vượt quá 10MB',
      });
      return;
    }

    this.isSearchingByImage = true;
    try {
      const platform = this.searchSite.toLowerCase() === '1688' ? '1688' : 'taobao';
      const result = await cartServices.uploadImageAndSearch(file, platform, 1, 20);
      if (result && result.status === 200 && result.data) {
        if (result.data.data && result.data.data.items) {
          this.products = result.data.data.items;
        } else if (result.data.items) {
          this.products = result.data.items;
        }
        this.closeImageSearchModal();
      } else {
        Vue.notify({
          group: 'foo',
          type: 'warning',
          title: 'Thông báo!',
          text: 'Không tìm thấy sản phẩm tương tự',
        });
      }
    } catch (error) {
      Vue.notify({
        group: 'foo',
        type: 'error',
        title: 'Lỗi!',
        text: 'Có lỗi xảy ra khi tìm kiếm bằng ảnh',
      });
    } finally {
      this.isSearchingByImage = false;
    }
  }

  private focusPasteArea() {
    this.isPasteFocused = true;
    if (this.showImageSearchModal && this.$refs.modalPasteArea) {
      (this.$refs.modalPasteArea as HTMLElement).focus();
    }
    setTimeout(() => {
      this.isPasteFocused = false;
    }, 10000);
  }

  private closeImageSearchModal() {
    this.showImageSearchModal = false;
    this.isPasteFocused = false;
    this.isDragOver = false;
  }

  private async handlePaste(event: ClipboardEvent) {
    event.preventDefault();
    const items = event.clipboardData && event.clipboardData.items;
    if (!items) { return; }
    for (const item of Array.from(items)) {
      if (item.type.indexOf('image') !== -1) {
        const file = item.getAsFile();
        if (file) {
          await this.processImageSearch(file);
        }
        break;
      }
    }
    this.isPasteFocused = false;
    if (this.$refs.modalPasteArea) {
      (this.$refs.modalPasteArea as HTMLElement).blur();
    }
  }
}
